import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';
import './signInModal.css';

export default function SignInModal() {
  const { showSignIn, closeSignIn, signIn } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!showSignIn) {
      setEmail('');
      setPassword('');
      setShowPassword(false);
      setError('');
      setSubmitting(false);
    }
  }, [showSignIn]);

  if (!showSignIn) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    const result = await signIn(email, password);
    if (!result.success) {
      setError(result.error);
      setSubmitting(false);
      return;
    }
    setSubmitting(false);
    navigate('/admin/activity');
  };

  return createPortal(
    <div className="signin-overlay" onClick={closeSignIn} role="presentation">
      <div
        className="signin-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="signin-title"
        aria-modal="true"
      >
        <button type="button" className="signin-close" onClick={closeSignIn} aria-label="Close">
          &times;
        </button>
        <h2 id="signin-title" className="signin-title">Members Only</h2>
        <p className="signin-subtitle">For authorized church members and staff only.</p>
        <form onSubmit={handleSubmit} className="signin-form">
          <label className="signin-label">
            Email
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="signin-input"
              autoComplete="username"
              required
            />
          </label>
          <label className="signin-label">
            Password
            <span className="signin-password-wrap">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="signin-input signin-input--password"
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                className="signin-password-toggle"
                onClick={() => setShowPassword((visible) => !visible)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </span>
          </label>
          {error && <p className="signin-error">{error}</p>}
          <button type="submit" className="signin-submit" disabled={submitting}>
            {submitting ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>,
    document.body
  );
}
